// pricingConfig.js - EDIT PRICES AND PROPERTY LIMITS HERE
// Changes here will automatically update the entire application.
// NOTE: keep in sync with backend/constants.js (SUBSCRIPTION_PLANS, TRIAL_DAYS) —
// the backend enforces limits/charges; this file drives everything shown in the UI.

// ── Global numbers (referenced across the whole site) ──
export const TRIAL_DAYS = 14;          // free trial length — starts at checkout (card on file, cancel anytime)
export const TENANT_FEE = 0;           // what tenants pay — ever
export const DELETION_GRACE_DAYS = 30; // account-deletion grace period (matches backend)
export const EXTENDED_STAY_MIN_DAYS = 30; // minimum extended-stay lease length
export const fmtPrice = (n) => Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;

export const PRICING_TIERS = {
  starter: {
    id: 'starter',
    name: 'Starter',
    price: 49.99,
    maxProperties: 3,
    maxTotalTenants: 15,
    maxTenantsPerProperty: 5,
    description: 'Perfect for getting started',
    features: [
      'Up to 3 properties',
      'Up to 15 total tenants',
      'Online rent collection',
      'Online rental applications',
      'Lease renewals & e-signing',
      'Portfolio analytics & rent roll',
      'Expense tracking',
      'Maintenance management',
      'Service provider directory',
      'Document storage',
      'Tenant portal access'
    ],
    popular: false
  },
  professional: {
    id: 'professional',
    name: 'Professional',
    price: 79.99,
    maxProperties: 5,
    maxTotalTenants: 25,
    maxTenantsPerProperty: 5,
    description: 'For growing portfolios',
    features: [
      'Up to 5 properties',
      'Up to 25 total tenants',
      'Everything in Starter',
      'Priority support',
      'Advanced reporting',
      'Receipt storage',
      'Tax-ready reports'
    ],
    popular: true
  },
  business: {
    id: 'business',
    name: 'Business',
    price: 120,
    maxProperties: 8,
    maxTotalTenants: 40,
    maxTenantsPerProperty: 6,
    description: 'For established landlords',
    features: [
      'Up to 8 properties',
      'Up to 40 total tenants',
      'Everything in Professional',
      'Bulk operations',
      'Custom categories',
      'API access'
    ],
    popular: false
  },
  enterprise: {
    id: 'enterprise',
    name: 'Enterprise',
    price: 160,
    maxProperties: 12,
    maxTotalTenants: 60,
    maxTenantsPerProperty: 25,
    description: 'Maximum flexibility — residential & commercial',
    features: [
      'Up to 12 properties',
      'Up to 60 total tenants',
      'Up to 25 units per property — salons, suites & complexes',
      'Everything in Business',
      'Dedicated support',
      'Custom integrations',
      'White-label options'
    ],
    popular: false
  }
};

export const SERVICE_PROVIDER_PRICING = {
  id: 'service_provider',
  name: 'Service Provider',
  price: 29,
  description: 'For contractors & service providers',
  features: [
    'Business profile listing',
    'Unlimited leads',
    'Direct messaging with landlords',
    'Customer reviews & ratings',
    'Service area targeting',
    'Priority in search results'
  ]
};

export const CUSTOM_PLAN = {
  name: 'Custom',
  description: 'For portfolios with 12+ properties',
  features: [
    'Unlimited properties',
    'Unlimited tenants',
    'Everything in Enterprise',
    'Custom pricing',
    'Dedicated account manager',
    'Custom feature development',
    'SLA guarantees'
  ]
};

// Helper function to get tier by property count

// Helper function to check if user can add more properties
export const canAddProperty = (currentCount, userTier) => {
  const tier = PRICING_TIERS[userTier];
  if (!tier) return false;
  return currentCount < tier.maxProperties;
};

// Helper function to check if user can add more tenants

// Helper function to get upgrade suggestion
export const getUpgradeSuggestion = (currentCount, userTier) => {
  const tier = PRICING_TIERS[userTier];
  if (!tier) return null;
  
  if (currentCount >= tier.maxProperties) {
    // Find next tier
    const tiers = Object.values(PRICING_TIERS);
    const currentIndex = tiers.findIndex(t => t.id === userTier);
    if (currentIndex < tiers.length - 1) {
      return tiers[currentIndex + 1];
    }
    return CUSTOM_PLAN;
  }
  return null;
};
